export const SURGICAL_TREATMENT_REQUEST = 'SURGICAL_TREATMENT_REQUEST';
export const SURGICAL_TREATMENT_REQUEST_SUCCESS = 'SURGICAL_TREATMENT_REQUEST_SUCCESS';
export const SURGICAL_TREATMENT_REQUEST_ERROR = 'SURGICAL_TREATMENT_REQUEST_ERROR';

export const BOOK_SURGERY_TREATMENT_REQUEST = 'BOOK_SURGERY_TREATMENT';
export const BOOK_SURGERY_TREATMENT_REQUEST_SUCCESS = 'BOOK_SURGERY_TREATMENT_REQUEST_SUCCESS';
export const BOOK_SURGERY_TREATMENT_REQUEST_ERROR = 'BOOK_SURGERY_TREATMENT_REQUEST_ERROR';

export const CLEAR_DATA_SURGERY_TREATMENT = 'CLEAR_DATA_SURGERY_TREATMENT';